export default __webpack_public_path__ + "static/media/Group7556.83a6163d.png";